import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GetDataPointsService {

  private mainSectionElement: any;

  // Extracts the element of the passed selector
  getElement(elem, selector) {
    this.mainSectionElement = null;
    for (; elem && elem !== document; elem = elem.parentNode) {
      if (selector) {
        if (elem.matches(selector)) {
          this.mainSectionElement = elem;
          break;
        }
        continue;
      }
    }
  }

  // Gets the main section element
  getMainSectionElement() {
    return this.mainSectionElement;
  }

  // Gets the main section container title
  getMainSectionHeading() {
    const headline = this.mainSectionElement?.parentNode.getAttribute('headline');
    return headline ? `${headline} > ` : '';
  }

  // Gets the sub section title
  getSubSectionHeading() {
    const sectionHeading = this.mainSectionElement?.querySelector('h2.section-heading');
    return sectionHeading ? `${sectionHeading.innerText} > ` : '';
  }

  // Gets the example viewer title
  getExampleViewerTitle() {
    const exampleViewerTitle = this.mainSectionElement?.querySelector('mat-toolbar>span.text-wrap');
    return exampleViewerTitle ? `${exampleViewerTitle.innerText} > ` : '';
  }

  // Gets the active code tab title
  getActiveCodeTab() {
    const activeCodeTab = this.mainSectionElement?.querySelector('div.mat-tab-label-active');
    return activeCodeTab ? `${activeCodeTab.innerText} > ` : '';
  }
}
